import { Component, OnChanges } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { cloneDeep } from 'lodash';


import { CoffeService } from '../../interfaces/CoffeService.interface';
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';

@IonicPage()
@Component({
  selector: 'page-coffe-shop-edit',
  templateUrl: 'coffe-shop-edit.html',
})
export class CoffeShopEditPage implements OnChanges{
  private cachedState: CoffeService[] = [];
  public selectedServices: CoffeService[] = [];
  public serviceName: string = '';
  public enableContinueButton: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, public coffeShopService: CoffeShopService, public viewCtrl: ViewController) {
  }

  ngOnChanges(state) {
    console.log(state);
  }
  ionViewWillEnter() {
    const services = this.navParams.get('services');
    this.selectedServices = cloneDeep(services);
    this.cachedState = cloneDeep(services);
    this.serviceName = this.selectedServices[0].name;
  }
  public dismiss() {
    this.viewCtrl.dismiss({ services: cloneDeep(this.selectedServices), cached: cloneDeep(this.cachedState) });
  }
  public goBack() {
    this.selectedServices.forEach((service) => service.selected = false);
    this.viewCtrl.dismiss();
  }
  public editService(service: CoffeService, index: number): void {
    service.selected = true;
  }
  public deleteService(service: CoffeService, index: number): void {
    this.enableContinueButton = true;
    this.selectedServices.splice(index, 1);
  }

  public updateService(service: CoffeService, index: number): void {
    service.selected = false;
  }
  
  calculateDopping(service: CoffeService, serviceIdx: number, dopping: any, index: number, type: 'plus' | 'minus') {
    if (this.selectedServices[serviceIdx].doppings[index].service_type === 1) {
      const sizes = this.selectedServices[serviceIdx].children.filter((children: CoffeService) => children.service_type === 1);
      const local_coffe_service: CoffeService = cloneDeep(this.selectedServices[serviceIdx]);
      delete local_coffe_service.children;
      delete local_coffe_service.doppings;
      local_coffe_service.selected = true;
      local_coffe_service.service_type = 1;
      local_coffe_service.price = 0;
      local_coffe_service.calculated_price = 0;
      sizes.unshift(local_coffe_service);
      const dopping_index = sizes.findIndex((size: CoffeService) => size.id === dopping.id);
      if (type === 'plus') {
       sizes[dopping_index + 1] ? this.selectedServices[serviceIdx].doppings[index] = sizes[dopping_index + 1] : null;
      }
      if (type === 'minus') {
        sizes[dopping_index - 1] ? this.selectedServices[serviceIdx].doppings[index] = sizes[dopping_index - 1] : null;
      
      }
      this.calculatePrice(serviceIdx);
      return;
    }
    
    if (type === 'minus' && this.selectedServices[serviceIdx].doppings[index].quantity > 0) {
      this.selectedServices[serviceIdx].doppings[index].quantity -= 1;
      this.selectedServices[serviceIdx].calculated_price -= this.selectedServices[serviceIdx].doppings[index].price;
    }
    if (type === 'plus') {
      this.selectedServices[serviceIdx].doppings[index].quantity += 1;
      this.selectedServices[serviceIdx].calculated_price += this.selectedServices[serviceIdx].doppings[index].price;
    }
    this.enableContinueButton = true;
  }
  private calculatePrice(serviceIdx: number): void {
    this.selectedServices[serviceIdx].calculated_price = this.selectedServices[serviceIdx].price;
    this.selectedServices[serviceIdx].doppings.forEach((dopping) => {
      dopping.service_type === 1 ? dopping.quantity = 1 : null;
      this.selectedServices[serviceIdx].calculated_price += dopping.price > 0 ? dopping.price * dopping.quantity : 0;
    });
    this.enableContinueButton = true;
  }
  public instructionsChange(instruction: string, service: CoffeService): void {
    if(this.cachedState.find((cached: CoffeService) => service.id === cached.id).special_instructions !== instruction) {
      this.enableContinueButton = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/coffe-shop-edit/coffe-shop-edit.ts